module.exports = __webpack_public_path__ + "static/img/Floor_WhiteWashed.70fc60d.jpg";